import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { Form } from 'formik';
import { MuiForm } from 'lib/Form';
import { SwitchFormField } from 'lib/form/fields/SwitchFormField';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { Row } from 'ui/Flex';

export interface LocationLinksFormData {
    facebook: string;
    twitter: string;
    instagram: string;
    citymapper: boolean;
    uber: boolean;
}

export const linksDefaults: LocationLinksFormData = {
    facebook: '',
    twitter: '',
    instagram: '',
    citymapper: false,
    uber: false
};

interface LocationLinksFormProps {
    open: boolean;
    onSubmit: (data: LocationLinksFormData) => void;
    onPrevious: () => void;
    initialValues: LocationLinksFormData;
}

export const LocationLinksForm: React.FC<LocationLinksFormProps> = ({
    open,
    onSubmit,
    onPrevious,
    initialValues
}) => {
    if (!open) {
        return null;
    }
    return (
        <MuiForm onSubmit={onSubmit} initialValues={initialValues}>
            {({ submitForm }) => (
                <Form>
                    <Box width="100%" sx={{ px: 3, pt: 1 }}>
                        <Typography variant="body2">
                            Set up the social media accounts linked to your location.
                        </Typography>
                    </Box>
                    <Box padding={3}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <TextFormField
                                    name="facebook"
                                    label="Facebook"
                                    description="This is the ID of the Facebook page you want to link to the location."
                                />
                            </Grid>
                            <Grid size={12}>
                                <TextFormField
                                    name="twitter"
                                    label="Twitter"
                                    description="This is the username of the Twitter account you want to link to the location."
                                />
                            </Grid>
                            <Grid size={12}>
                                <TextFormField
                                    name="instagram"
                                    label="Instagram"
                                    description="This is the username of the Instagram page you want to link to the location."
                                />
                            </Grid>
                            <Grid size={12}>
                                <SwitchFormField name="citymapper" label="Citymapper" />
                            </Grid>
                            <Grid size={12}>
                                <SwitchFormField name="uber" label="Uber" />
                            </Grid>
                            <Grid size={12}>
                                <Row align="flex-end" gutter>
                                    <Button onClick={onPrevious} color="primary" variant="outlined">
                                        Back
                                    </Button>
                                    <Button onClick={submitForm} color="primary" variant="contained">
                                        Next
                                    </Button>
                                </Row>
                            </Grid>
                        </Grid>
                    </Box>
                </Form>
            )}
        </MuiForm>
    );
};
